var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.70105 0.298952L0.662913 5.33709C0.488237 5.51351 0.39025 5.75174 0.39025 6C0.39025 6.24826 0.488237 6.48649 0.662913 6.66291L5.70105 11.701C5.87747 11.8757 6.1157 11.9737 6.36396 11.9737C6.61222 11.9737 6.85046 11.8757 7.02687 11.701L12.065 6.66291C12.2397 6.48649 12.3377 6.24826 12.3377 6C12.3377 5.75174 12.2397 5.51351 12.065 5.33709L7.02687 0.298952C6.85046 0.124276 6.61222 0.0262896 6.36396 0.0262893C6.1157 0.026289 5.87747 0.124276 5.70105 0.298952ZM8.3527 3.21577L6.36396 5.2045L4.37522 3.21577L6.36396 1.22703L8.3527 3.21577ZM3.57973 4.01126L5.56847 6L3.57973 7.98874L1.59099 6L3.57973 4.01126ZM4.37522 8.78423L6.36396 6.7955L8.3527 8.78423L6.36396 10.773L4.37522 8.78423ZM9.14819 7.98874L7.15946 6L9.14819 4.01126L11.1369 6L9.14819 7.98874Z",
    fill: "#D220FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquare);
export default __webpack_public_path__ + "static/media/square.3c8d86abcc26f5fc82d480f17348a99f.svg";
export { ForwardRef as ReactComponent };